import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/Select/Select';
import { useState } from 'react';
import { cn } from '@/lib/utils.ts';
import { Label } from '@radix-ui/react-label';
import { useTranslation } from 'react-i18next';
import Image from '@/components/ui/Image/Image';

export interface Option {
  label: string;
  value: string;
  icon?: string;
}

interface SelectComponentProps {
  value: string | undefined;
  label?: string;
  placeholder?: string;
  options?: Option[];
  handleChange: (value: string) => void;
  width?: string;
  error?: string;
  className?: string;
  labelClassName?: string;
}

export function SelectComponent(props: SelectComponentProps) {
  const { t } = useTranslation();
  const {
    value,
    label,
    placeholder,
    className,
    error,
    width,
    options,
    handleChange,
    labelClassName,
  } = props;

  const [selectedValue, setSelectedValue] = useState<string | undefined>(value);

  const onSelectChange = (value: string) => {
    setSelectedValue(value);
    handleChange(value);
  };

  const selectedOption = options?.find(
    option => option?.value === selectedValue
  );

  return (
    <div style={{ width }} className={cn('flex flex-col gap-2 mb-[12px]', className)}>
      {label &&
        <Label
          className={
            labelClassName ??
            cn(
              error ? 'text-[#B00120]' : '',
            )}
        >
          {label}
        </Label>
      }

      <Select onValueChange={onSelectChange}>
        <SelectTrigger
          style={{ width }}
          className={cn("h-14 rounded-sm", error ? "bg-[#FDF7F8] border border-[#B00120]" : "bg-[#F7F7F7]")}
        >
          <SelectValue
            placeholder={placeholder || t('activation.selectPlaceholder')}
            label={selectedOption?.label}
            icon={selectedOption?.icon}
          />
        </SelectTrigger>
        <SelectContent>
          {options?.map(option => (
            <SelectItem key={option.value} value={option.value}>
              <div className="flex items-center">
                {option.icon && (
                  <Image
                    src={option.icon}
                    alt={`${option.label}-icon`}
                    className="mr-2 h-4 w-4 rounded-full"
                  />
                )}
                {option.label}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && <p className="text-[#B00120] text-bodyMedium">{error}</p>}
    </div>
  );
}
